import type { RootState } from '@/store';

export const selectSentencaArbitral = (state: RootState) => state.sentencaArbitral.sentenca;
export const selectSentencaArbitralLoading = (state: RootState) => state.sentencaArbitral.loading;
export const selectSentencaArbitralError = (state: RootState) => state.sentencaArbitral.error;
export const selectSentencaArbitralSemPermissao = (state: RootState) =>
  state.sentencaArbitral.semPermissao;
export const selectSentencaArbitralNaoPublicada = (state: RootState) =>
  state.sentencaArbitral.naoPublicada;
